import React from 'react';

import { EllipseMob } from './EllipseMob.styled';

const PageEllipseMob = () => {
  return (
    <EllipseMob
    src={require('./Png/EllipseMob.png')}
                alt="EllipseMob"/>
     
    
  );
};

export default PageEllipseMob;